module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-20.606e1cb0.png";